export default __webpack_public_path__ + "static/media/cover-image.fb79697c.svg";